import React, { useState, useEffect } from 'react';
import MobileOrderDetails from './MobileOrderDetails';
import DesktopOrderDetails from './DesktopOrderDetails';

const CustomerOrderDetails = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < 1024);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isMobile ? <MobileOrderDetails /> : <DesktopOrderDetails />;
};

export default CustomerOrderDetails;
